// Napisy interfejsu w dwóch językach (patch-33): cała aplikacja idzie za przełącznikiem EN/PL (ten sam, co język uwag bota w lekcji).
// Pliki ekranów trzymają swoje napisy jako pary `{ en, pl }` (słownik `T` na górze pliku); polskie napisy mogą mieć formy płci `{y|a}` (lib/gender.ts).
import type { TeacherLang } from '../types.ts';

export type Pair = Readonly<Record<TeacherLang, string>>;

/** Język, gdy aplikacja nie ma ustawień nauczyciela (testy widoków na atrapach); w prawdziwej aplikacji `ctx.teacher` jest zawsze. */
export const FALLBACK_LANG: TeacherLang = 'pl';

/** Liczba mnoga po angielsku: 1 word, 2 words. */
export const enPlural = (n: number, one: string, many: string): string => (n === 1 ? one : many);
